import React from 'react';
import './App.css';

import shirokuma from './images/shirokuma.png';
import counselor from './images/counselor.png';
import logo from './images/logo.png';


class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accessToken: '',
      isLoading: true,
      classStart: '',
      classQuestion: 'd-none',
      questionOrder: 1,
      remainingQuestion: 6,
      classUnselectedError: 'd-none',
      questionId: 'q10000',
      questionText: '何歳ですか？',
      answerType: '1',
      answerList: [
        { choiceID: "1", choices: "18歳未満", image: "" },
        { choiceID: "2", choices: "18歳以上", image: "" }
      ],
      routeMaster: [{
        questionID: "q10000",
        nextQuestion: "何歳ですか？",
        answerType: "1",
        answerList: [
          { choiceID: "1", choices: "18歳未満", image: "" },
          { choiceID: "2", choices: "18歳以上", image: "" }
        ]
      }],
      choiceId: '',
      classResult: 'd-none',
      resultId: '',
      result: '',
      relationalArticlesList: [],
      otherCandidatesList: [],
      classArticle: 'd-none',
      articleTitle: '',
      articleThumbnail: '',
      articleContents: '',
    }

    this.componentDidMount = this.componentDidMount.bind(this);
    this.startConsult = this.startConsult.bind(this);
    this.selectOption = this.selectOption.bind(this);
    this.selectOptionForCard = this.selectOptionForCard.bind(this);
    this.goToNextQuestion = this.goToNextQuestion.bind(this);
    this.backToPrevQuestion = this.backToPrevQuestion.bind(this);
    this.goToResult = this.goToResult.bind(this);
    this.consultAgain = this.consultAgain.bind(this);
    this.goToArticle = this.goToArticle.bind(this);
    this.backToResult = this.backToResult.bind(this);
    this.createMarkup = this.createMarkup.bind(this);
  }

  componentDidMount() {
    // GETパラメータを取得
    const param = window.location.search;

    // GETパラメータが設定されていない場合
    if (!param) {
      // 認可取得I/Fを呼び出す
      const url = new URL('https://id.my.softbank.jp/sbid_auth/type1/2.0/authorization.php?');
      const params = url.searchParams;

      const response_type = 'code';
      const client_id = 'JWHSiSWwMphiDSAVmBLnyg5Lw9etYySy';
      const redirect_uri = 'https://netsodan-s.com/';
      const scope = 'openid cdp';
      const nonce = Math.random().toString(32).substring(2);
      console.log(nonce);

      params.append('response_type', response_type);
      params.append('client_id', client_id);
      params.append('redirect_uri', redirect_uri);
      params.append('scope', scope);
      params.append('nonce', nonce);

      window.location.href = url;
    } else {
      // パラメータからコードを取得する
      console.log(param);
      const code = param.substring(param.indexOf('=') + 1);

      // コードをもとにログイン可否の判定を行う
      const url = 'https://fpco9nl5qk.execute-api.ap-northeast-1.amazonaws.com/prd/auth';
      const method = 'POST';
      const submitBody = {
        code: code
      };
      const body = JSON.stringify(submitBody);

      fetch(url, { method, body })
        .then((res) => {
          console.log(res.status);
          if (res.ok) {
            return res.json()
              .then((resJson) => {
                console.log(res.status);
                // アクセストークンをstateに設定
                this.setState({ accessToken: resJson['access_token'] });
                // ロード中フラグをfalseに変更
                this.setState({ isLoading: false });

                // GETパラメータを削除
                let url = new URL(window.location.href);
                let params = url.searchParams;
                params.delete('code');

                // アドレスバーからGETパラメータを削除
                const history = window.history;
                history.replaceState('', '', url.pathname);
              })
          }
          console.log(res.status);
          // ロード中フラグをfalseに変更
          this.setState({ isLoading: false });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  startConsult() {
    // 相談開始画面を非表示
    this.setState({ classStart: 'd-none' });
    // 質問画面を表示
    this.setState({ classQuestion: '' });
    window.scroll({ top: 0, behavior: 'smooth' });
  }

  selectOption(event) {
    const target = event.currentTarget;
    const radio = target.querySelector('input');
    radio.checked = true;
    this.setState({ choiceId: radio.value });
  }

  selectOptionForCard(event) {
    const target = event.currentTarget;
    const radio = target.querySelector('input');
    radio.checked = true;
    this.setState({ choiceId: radio.value });

    // 全てのcardの背景色を'#fff'に、文字色を'#F27E88'にして、画像を差替える
    const cards = [...document.getElementsByClassName('card mb-3')];
    cards.forEach(function (element) {
      element.style.backgroundColor = '#fff';
      element.querySelector('p').style.cssText = 'color:#F27E88 !important;';

      const img = element.querySelector('img');
      const src = img.getAttribute('src');
      const repSrc = src.replace('_w', '');
      img.setAttribute('src', repSrc);
    })

    // 選択したcardの背景色を'#F27E88'に、文字色を'#fff'にして、画像を差替える
    target.style.backgroundColor = '#F27E88';
    target.querySelector('p').style.cssText = 'color:#fff !important;';

    const img = target.querySelector('img');
    const src = img.getAttribute('src');
    const subSrc = src.substring(0, src.indexOf('.'));
    img.setAttribute('src', subSrc + '_w.png');
  }

  goToNextQuestion() {
    // 回答が選択されているかチェック
    let checked = false;
    const options = document.getElementsByName('options');
    options.forEach(function (element) {
      if (element.checked) {
        checked = true;
      }
    })

    if (checked) {
      // 質問番号、選択肢連番をもとに次の質問を取得
      const url = 'https://fpco9nl5qk.execute-api.ap-northeast-1.amazonaws.com/prd/question';
      const method = 'POST';
      const headers = { access_token: this.state.accessToken };
      const submitBody = {
        questionID: this.state.questionId,
        choiceID: this.state.choiceId,
      };
      const body = JSON.stringify(submitBody);

      fetch(url, { method, headers, body })
        .then((res) => {
          return res.json();
        })
        .then((resJson) => {
          // 次の質問の質問番号、質問文、回答形式、選択肢リストをstateに設定
          this.setState({
            questionId: resJson['questionID'],
            questionText: resJson['nextQuestion'],
            answerType: resJson['answerType'],
            answerList: resJson['answerList']
          });

          // 戻る用の情報をstateに設定
          let copyRouteMaster = [...this.state.routeMaster];
          copyRouteMaster.push({
            questionID: resJson['questionID'],
            nextQuestion: resJson['nextQuestion'],
            answerType: resJson['answerType'],
            answerList: resJson['answerList']
          });
          this.setState({ routeMaster: copyRouteMaster });

          // 質問番号をカウントアップしてstateに設定
          this.setState({ questionOrder: this.state.questionOrder + 1 });

          // 残り質問数をカウントダウンしてstateに設定
          this.setState({ remainingQuestion: this.state.remainingQuestion - 1 });

          // エラーメッセージを非表示
          this.setState({ classUnselectedError: 'd-none' })

          // 回答の選択を解除
          const options = document.getElementsByName('options');
          options.forEach(function (element) {
            element.checked = false;
          })

          // 質問画面を表示
          this.setState({ classQuestion: '' });
          window.scroll({ top: 0, behavior: 'smooth' });
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      // エラーメッセージを表示
      this.setState({ classUnselectedError: 'alert alert-danger' })
    }
  }

  backToPrevQuestion() {
    // 戻り先が相談開始画面か質問画面か判定
    if (this.state.routeMaster.length > 1) {
      // 配列の最後の要素を削除
      this.state.routeMaster.pop();
      const copyRouteMaster = [...this.state.routeMaster];
      this.setState({ routeMaster: copyRouteMaster });

      // 前の質問の質問番号、質問文、回答形式、選択肢リストをstateに設定
      this.setState({
        questionId: this.state.routeMaster[this.state.routeMaster.length - 1].questionID,
        questionText: this.state.routeMaster[this.state.routeMaster.length - 1].nextQuestion,
        answerType: this.state.routeMaster[this.state.routeMaster.length - 1].answerType,
        answerList: this.state.routeMaster[this.state.routeMaster.length - 1].answerList
      });

      // 質問番号をカウントダウンしてstateに設定
      this.setState({ questionOrder: this.state.questionOrder - 1 });

      // 残り質問数をカウントアップしてstateに設定
      this.setState({ remainingQuestion: this.state.remainingQuestion + 1 });

      // 質問画面を表示
      this.setState({ classQuestion: '' });
      window.scroll({ top: 0, behavior: 'smooth' });
    } else {
      // 質問画面を非表示
      this.setState({ classQuestion: 'd-none' });
      // 相談開始画面を表示
      this.setState({ classStart: '' });
      window.scroll({ top: 0, behavior: 'smooth' });
    }
    // エラーメッセージを非表示
    this.setState({ classUnselectedError: 'd-none' })

    // 回答の選択を解除
    const options = document.getElementsByName('options');
    options.forEach(function (element) {
      element.checked = false;
    })
  }

  goToResult() {
    // 回答が選択されているかチェック
    let checked = false;
    let checkedArray = [];
    const formGroup = [...document.getElementsByClassName('form-group')];
    formGroup.forEach(function (element) {
      const options = element.querySelectorAll('[name^="options"]');
      options.forEach(function (element) {
        if (element.checked) {
          checkedArray.push(true);
        }
      })
    })

    // 選択肢の数と回答数を比較
    if (formGroup.length === checkedArray.length) {
      checked = true;
    }

    if (checked) {
      // 質問番号「qXXXXX」を結果分類番号「eXXXXX」に変換
      const resultTypeId = this.state.questionId.replace('q', 'e');

      // 各質問の選択肢を連結して、最終選択肢とする
      const selectedChoice = document.querySelectorAll('input:checked');
      let lastChoiceId = '';
      selectedChoice.forEach(function (element) {
        lastChoiceId += element.value;
      })

      // 結果分類番号、最終選択肢をもとに診断結果を取得
      const url = 'https://fpco9nl5qk.execute-api.ap-northeast-1.amazonaws.com/prd/result';
      const method = 'POST'
      const headers = { access_token: this.state.accessToken };
      const submitBody = {
        resultTypeID: resultTypeId,
        lastChoiceID: lastChoiceId
      };
      const body = JSON.stringify(submitBody);

      fetch(url, { method, headers, body })
        .then((res) => {
          return res.json();
        })
        .then((resJson) => {
          // 診断結果ID、診断結果をstateに設定
          this.setState({
            resultId: resJson['resultID'],
            result: resJson['result'],
          });

          console.log(resJson['relationalArticlesList']);
          const relationalArticlesIdList = resJson['relationalArticlesList'];
          console.log(relationalArticlesIdList);

          // 記事番号をもとに記事情報を取得
          const url = 'https://fpco9nl5qk.execute-api.ap-northeast-1.amazonaws.com/prd/article';
          const method = 'POST';
          const headers = { access_token: this.state.accessToken };
          const submitBody = {
            url: 'https://sns1.microcms.io/api/v1/nettrouble?ids=' + relationalArticlesIdList + '&limit=100'
          };
          const body = JSON.stringify(submitBody);

          fetch(url, { method, headers, body })
            .then((res) => {
              console.log(res.status);
              if (res.ok) {
                return res.json()
                  .then((resJson) => {
                    console.log(res.status);
                    // microCMSから取得した記事情報を診断結果管理マスタから取得したIDの順にソート
                    const relationalArticlesList = resJson['article']['contents'];
                    console.log(relationalArticlesList);
                    relationalArticlesList.sort((a, b) => relationalArticlesIdList.indexOf(a.id) - relationalArticlesIdList.indexOf(b.id));
                    console.log(relationalArticlesList);

                    // 記事情報をstateに設定
                    this.setState({ relationalArticlesList: relationalArticlesList });
                    this.setState({ otherCandidatesList: relationalArticlesList });

                    // エラーメッセージを非表示
                    this.setState({ classUnselectedError: 'd-none' })

                    // 質問画面を非表示
                    this.setState({ classQuestion: 'd-none' });
                    // 相談結果画面を表示
                    this.setState({ classResult: '' });
                    window.scroll({ top: 0, behavior: 'smooth' });

                    // GA4にカスタムイベントを送信
                    window.gtag('event', 'result', { 'value': this.state.resultId });
                  })
              } else {
                console.log(res.status);
                // ページを再読み込み
                window.location.reload();
              }
            })
            .catch((error) => {
              console.log(error);
              // ページを再読み込み
              window.location.reload();
            });
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      // エラーメッセージを表示
      this.setState({ classUnselectedError: 'alert alert-danger' })
    }
  }

  consultAgain() {
    // stateを初期化
    this.setState({
      classStart: '',
      classQuestion: 'd-none',
      questionOrder: 1,
      remainingQuestion: 6,
      classUnselectedError: 'd-none',
      questionId: 'q10000',
      questionText: '何歳ですか？',
      answerType: '1',
      answerList: [
        { choiceID: "1", choices: "18歳未満", image: "" },
        { choiceID: "2", choices: "18歳以上", image: "" }
      ],
      routeMaster: [{
        questionID: "q10000",
        nextQuestion: "何歳ですか？",
        answerType: "1",
        answerList: [
          { choiceID: "1", choices: "18歳未満", image: "" },
          { choiceID: "2", choices: "18歳以上", image: "" }
        ]
      }],
      choiceId: '',
      classResult: 'd-none',
      resultId: '',
      result: '',
      relationalArticlesList: [],
      otherCandidatesList: [],
      classArticle: 'd-none',
      articleTitle: '',
      articleThumbnail: '',
      articleContents: '',
    });

    window.scroll({ top: 0, behavior: 'smooth' });
  }

  goToArticle(event) {
    // 記事IDを取得
    const target = event.currentTarget;
    const input = target.querySelector('input');
    const articleId = input.value;

    // 記事IDをもとに記事情報を取得
    const url = 'https://fpco9nl5qk.execute-api.ap-northeast-1.amazonaws.com/prd/article';
    const method = 'POST';
    const headers = { access_token: this.state.accessToken };
    const submitBody = {
      url: 'https://sns1.microcms.io/api/v1/nettrouble/' + articleId
    };
    const body = JSON.stringify(submitBody);

    fetch(url, { method, headers, body })
      .then((res) => {
        console.log(res.status);
        if (res.ok) {
          return res.json()
            .then((resJson) => {
              console.log(res.status);
              // 記事のタイトル、サムネイル、コンテンツをstateに設定
              this.setState({
                articleTitle: resJson['article']['title'],
                articleThumbnail: resJson['article']['thumbnail']['url'],
                articleContents: resJson['article']['contents'],
              });

              // その他の候補リストを関連記事リストでリセット
              const copyRelationalArticlesList = [...this.state.relationalArticlesList];
              this.setState({ otherCandidatesList: copyRelationalArticlesList });
              // その他の候補リストから選択した記事IDを削除
              const tmpOtherCandidatesList = this.state.otherCandidatesList.filter(index => !articleId.includes(index.id));
              this.setState({ otherCandidatesList: tmpOtherCandidatesList });

              // 相談結果画面を非表示
              this.setState({ classResult: 'd-none' });
              // 記事画面を表示
              this.setState({ classArticle: '' });
              window.scroll({ top: 0, behavior: 'smooth' });

              // GA4にカスタムイベントを送信
              window.gtag('event', 'article', { 'value': articleId });
            })
        } else {
          console.log(res.status);
          // ページを再読み込み
          window.location.reload();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  backToResult() {
    // その他の候補リストを関連記事リストでリセット
    const copyRelationalArticlesList = [...this.state.relationalArticlesList];
    this.setState({ otherCandidatesList: copyRelationalArticlesList });

    // 記事画面を非表示
    this.setState({ classArticle: 'd-none' });
    // 相談結果画面を表示
    this.setState({ classResult: '' });
    window.scroll({ top: 0, behavior: 'smooth' });
  }

  createMarkup(text) {
    return { __html: text.replace(/<img/g, '<img class="w-100 py-3"') };
  }

  render() {
    return (
      <div>
        {(() => {
          if (this.state.isLoading) {
            return <div className="alert alert-secondary m-2" role="alert">
              <h1 className="fs-4 alert-heading">認証処理中</h1>
              <hr />
              <p>セキュリティパックプラスの加入状況を確認し、ネットトラブル相談室が利用できるか確認しています。</p>
            </div>
          } else {
            if (this.state.accessToken) {
              return <div>
                {/* 相談開始 */}
                <div className={this.state.classStart}>
                  <div className="container-fluid bg-info pt-5 pb-5 justifycontent">
                    <div className="row justifycontent mt-5 mb-3">
                      <div className="mw-sm flexstart">
                        <img className="w-100 h-kuma" src={shirokuma} alt="シロクマ" />
                      </div>
                      <p className="heading04 text-dark mt-5">心配ごとを気軽にチェック！</p>
                      <h1 className="sitetitle text-white mt-0">ネットトラブル相談室</h1>
                    </div>
                    <div className="text-center mx-3 mb-3">
                      <button type="button" className="btn btn-line btn-lg mw-sm" onClick={this.startConsult}>はじめる</button>
                    </div>
                    <div>
                      <p className="text-center fw-bold text-light">個別の法律相談ではありません</p>
                      <p className="text-center fw-bold text-light">診断結果に応じて役立つ記事が読めます</p>
                    </div>
                  </div>
                </div>
                {/* 質問 */}
                <div className={this.state.classQuestion}>
                  <div className="container-fluid mb-4">
                    <div className="row bg-info text-white py-3">
                      <div className="col-8">
                        <p className="fs-6 mb-0" onClick={this.backToPrevQuestion}>&larr;前に戻る</p>
                      </div>
                      <div className="col-4">
                        <p className="fs-6 mb-0 text-right">{'あと' + this.state.remainingQuestion + '問'}</p>
                      </div>
                    </div>
                  </div>
                  {(() => {
                    if (this.state.answerType === "1") {
                      return <div className="container mw vh-80 small-height">
                        <div className="row mb-3">
                          <h1 className="fs-2 text-dark"><span className="balloon">{"Q" + this.state.questionOrder}</span>{this.state.questionText}</h1>
                        </div>
                        <div className="row mb-3">
                          <div className="form-group">
                            {this.state.answerList.map(function (index, i) {
                              return <div className="form-check mb-3 w-100" key={i} onClick={this.selectOption} >
                                <input type="radio" className="btn-check" name="options" id={"options_" + (i + 1)} value={index.choiceID} autoComplete="off" />
                                <label className="btn btn-lg btn-outline-info" htmlFor={"options_" + (i + 1)} >{index.choices}</label>
                              </div>;
                            }, this)}
                          </div>
                        </div>
                        <div className={this.state.classUnselectedError}>
                          回答を選択してください
                        </div>
                        <div className="text-center">
                          <button type="button" className="btn btn-light btn-lg mt-3 mb-5" onClick={this.goToNextQuestion}>次の質問へ</button>
                        </div>
                      </div>
                    } else if (this.state.answerType === "2") {
                      return <div className="container mw">
                        <div className="row mb-3">
                          <h1 className="fs-2 text-dark"><span className="balloon">{"Q" + this.state.questionOrder}</span>{this.state.questionText}</h1>
                        </div>
                        <div className="row mb-3">
                          <div className="form-group">
                            {this.state.answerList.map(function (index, i) {
                              return <div className="card mb-3" key={i} onClick={this.selectOptionForCard}>
                                <div className="row g-0">
                                  <div className="col-3 p-3 text-center">
                                    <img src={`${process.env.PUBLIC_URL}` + index.image} alt="選択肢" className="img-fluid rounded-start" width="70px" />
                                  </div>
                                  <div className="col-9 d-flex align-items-center">
                                    <div className="card-body">
                                      <input type="radio" className="btn-check" name="options" id={"options_" + (i + 1)} value={index.choiceID} autoComplete="off" />
                                      <p className="mb-0 text-info fw-bold" htmlFor={"options_" + (i + 1)} >{index.choices}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>;
                            }, this)}
                          </div>
                        </div>
                        <div className={this.state.classUnselectedError}>
                          回答を選択してください
                        </div>
                        <div className="text-center">
                          <button type="button" className="btn btn-light btn-lg mt-3 mb-5" onClick={this.goToNextQuestion}>次の質問へ</button>
                        </div>
                      </div>
                    } else if (this.state.answerType === "3") {
                      return <div className="container mw">
                        <div className="row mb-3">
                          <h1 className="fs-2 text-dark"><span className="balloon">{"Q" + this.state.questionOrder}</span>{this.state.questionText}</h1>
                        </div>
                        {this.state.answerList.map(function (index, i) {
                          return <div className="row mb-3 mx-1" key={i}>
                            <div className="bg-light">
                              <div className="card-body">
                                <span className="badge">{this.state.questionOrder + "-" + (i + 1)}</span>
                                <p className="fs-5 mb-3 fw-bold">{index.choices}</p>
                                <div className="form-group">
                                  <div className="form-check form-check-inline" onClick={this.selectOption}>
                                    <input type="radio" className="btn-check" name={"options_" + (i + 1)} id={"options_" + (i + 1) + "_1"} value="1" autoComplete="off" />
                                    <label className="btn btn-lg btn-outline-info" htmlFor={"options_" + (i + 1) + "_1"}>はい</label>
                                  </div>
                                  <div className="form-check form-check-inline" onClick={this.selectOption}>
                                    <input type="radio" className="btn-check" name={"options_" + (i + 1)} id={"options_" + (i + 1) + "_0"} value="0" autoComplete="off" />
                                    <label className="btn btn-lg btn-outline-info" htmlFor={"options_" + (i + 1) + "_0"}>いいえ</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>;
                        }, this)}
                        <div className={this.state.classUnselectedError}>
                          回答を選択してください
                        </div>
                        <div className="text-center">
                          <button type="button" className="btn btn-light btn-lg mt-3 mb-5" onClick={this.goToResult}>相談結果を見る</button>
                        </div>
                      </div>
                    }
                  })()}
                </div>
                {/* 相談結果 */}
                <div className={this.state.classResult}>
                  <div className="container-fluid bg-info pt-5 mb-5">
                    <div className="container mw">
                      <div className="row text-center mb-3">
                        <h1 className="fs-4 text-white fw-bold">ネットトラブル相談室</h1>
                        <h1 className="fs-1 text-white fw-bold">相談結果</h1>
                      </div>
                      <div className="row mx-1">
                        <div className="rounded bg-white text-start">
                          <p className="pt-3 pb-2 px-2">{this.state.result}</p>
                        </div>
                      </div>
                      <div className="text-center mx-3">
                        <button type="button" className="btn btn-line btn-lg my-5" onClick={this.consultAgain}>もう一度相談する</button>
                      </div>
                    </div>
                  </div>
                  <div className="container mw mb-2">
                    <div className="row text-center">
                      <p className="text-dark heading05">「セキュリティパックプラス」加入者限定
                        <br />
                        スペシャルコンテンツ
                      </p>
                    </div>
                  </div>
                  <div className="container mw mb-5">
                    {this.state.relationalArticlesList.map(function (index, i) {
                      return <div className="card mb-2" key={i} onClick={this.goToArticle}>
                        <div className="row g-0">
                          <div className="col-3">
                            <img src={index.thumbnail.url} alt="関連記事サムネイル" className="mw-100 rounded-start" height="64px" />
                          </div>
                          <div className="col-9 d-flex align-items-center">
                            <div className="m-2">
                              <p className="text-info mb-0">{index.title.length <= 23 ? index.title : index.title.substring(0, 23).concat('…')}</p>
                              <input type="hidden" value={index.id}></input>
                            </div>
                          </div>
                        </div>
                      </div>;
                    }, this)}
                  </div>
                  <div className="container mw mb-5">
                    <div className="rounded bg-light p-3">
                      <div className="row text-center">
                        <p className="text-dark heading06">カウンセラーにLINE相談</p>
                      </div>
                      <div className="row text-center flexstart">
                        <img className="w-100 mh-counselor" src={counselor} alt="カウンセラー" />
                      </div>
                      <div className="row text-left">
                        <p className="pt-3 pb-1 px-2">あなたの悩みを、カウンセラーに相談できます。まずは、ネットトラブル相談室公式アカウントと友達になって、あなたの悩みに応えてくれるカウンセラーを探してみましょう！</p>
                        <p className="subcontent pb-2 px-2"><span className="text-danger">「カウンセラーにLINE相談」は「セキュリティパックプラス」のサービスではありません。</span>LINE公式アカウント・カウンセラーへの友達登録は無料です。カウンセラーとの相談日程確定後、<span className="text-danger">別途料金</span>の決済が必要です。</p>
                      </div>
                      <div className="row text-center pb-3">
                        <a href="https://lin.ee/kMGV6Eln"><img src="https://scdn.line-apps.com/n/line_add_friends/btn/ja.png" alt="友だち追加" height="50" border="0" /></a>
                      </div>
                    </div>
                  </div>
                </div>
                {/* 記事 */}
                <div className={this.state.classArticle}>
                  <div className="container-fluid mb-4">
                    <div className="row bg-info text-white py-3">
                      <p className="fs-6 mb-0" onClick={this.backToResult}>&larr;前に戻る</p>
                    </div>
                  </div>
                  <div className="container mw">
                    <div className="container">
                      <h1 className="fs-2 text-dark">{this.state.articleTitle}</h1>
                      <img className="w-100 py-3" src={this.state.articleThumbnail} alt="記事イメージ" />
                      <div dangerouslySetInnerHTML={this.createMarkup(this.state.articleContents)} />
                    </div>
                    <div className="container mb-4">
                      <div className="row text-info py-3">
                        <p className="fs-6 mb-0" onClick={this.backToResult}>&larr;前に戻る</p>
                      </div>
                    </div>
                    <div className="container mb-2">
                      <div className="row">
                        <p className="text-dark fs-4 fw-bold mb-0">その他の候補</p>
                      </div>
                    </div>
                    <div className="container mb-5">
                      {this.state.otherCandidatesList.map(function (index, i) {
                        return <div className="card mb-2" key={i} onClick={this.goToArticle}>
                          <div className="row g-0">
                            <div className="col-3">
                              <img src={index.thumbnail.url} alt="その他の候補サムネイル" className="mw-100 rounded-start" height="64px" />
                            </div>
                            <div className="col-9 d-flex align-items-center">
                              <div className="m-2">
                                <p className="text-info mb-0">{index.title.length <= 25 ? index.title : index.title.substring(0, 25).concat('…')}</p>
                                <input type="hidden" value={index.id}></input>
                              </div>
                            </div>
                          </div>
                        </div>;
                      }, this)}
                    </div>
                    <div className="container mb-5">
                      <div className="rounded bg-light p-3">
                        <div className="row text-center">
                          <p className="text-dark heading06">カウンセラーにLINE相談</p>
                        </div>
                        <div className="row text-center flexstart">
                          <img className="w-100 mh-counselor" src={counselor} alt="カウンセラー" />
                        </div>
                        <div className="row text-left">
                          <p className="pt-3 pb-1 px-2">あなたの悩みを、カウンセラーに相談できます。まずは、ネットトラブル相談室公式アカウントと友達になって、あなたの悩みに応えてくれるカウンセラーを探してみましょう！</p>
                          <p className="subcontent pb-2 px-2"><span className="text-danger">「カウンセラーにLINE相談」は「セキュリティパックプラス」のサービスではありません。</span>LINE公式アカウント・カウンセラーへの友達登録は無料です。カウンセラーとの相談日程確定後、<span className="text-danger">別途料金</span>の決済が必要です。</p>
                        </div>
                        <div className="row text-center pb-3">
                          <a href="https://lin.ee/kMGV6Eln"><img src="https://scdn.line-apps.com/n/line_add_friends/btn/ja.png" alt="友だち追加" height="50" border="0" /></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* フッター */}
                <div className="footer py-3 vh-10">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12 text-center d-md-flex align-items-center"> <i className="d-block fa fa-stop-circle fa-2x mr-md-5 text-primary"></i>
                        <ul className="nav mx-md-auto d-flex justify-content-center">
                          <li className="nav-item"> <img className="" src={logo} alt="マモル コーポレートロゴ" width="80px" /> </li>
                          <li className="nav-item"> <a className="nav-link" href="https://tayori.com/form/17276c0631585a2c288d494a69ca0d2d1dca448a/" target="_blank" rel="noopener noreferrer">お問合せ</a> </li>
                          <li className="nav-item"> <a className="nav-link" href="https://mamor.jp/netsodan_terms/" target="_blank" rel="noopener noreferrer">ご利用規約</a> </li>
                          <li className="nav-item"> <a className="nav-link" href="https://mamor.jp/netsodan_policy/" target="_blank" rel="noopener noreferrer">プライバシーポリシー</a> </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            } else {
              return <div className="alert alert-danger m-2" role="alert">
                <h1 className="fs-4 alert-heading">セキュリティパックプラスのご利用がありません。</h1>
                <hr />
                <p>セキュリティパックプラス未加入の方は、<a href="https://netsodan.com/">こちら</a>からネットトラブル相談室をご利用ください。</p>
              </div>
            }
          }
        })()}
      </div>
    );
  }
}

export default App;